var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircleSolidGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.332,
    height: 22.332,
    viewBox: "0 0 22.332 22.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1e9771;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.2,16.089c-.089-.089-.143-.134-.2-.188-.75-.75-1.5-1.5-2.259-2.25a1.53,1.53,0,0,0-.223-.2,1.018,1.018,0,0,0-1.214,0,1.032,1.032,0,0,0-.045,1.652q1.567,1.567,3.152,3.134a.9.9,0,0,0,.277.205.984.984,0,0,0,1.259-.25q3.228-3.214,6.447-6.429c.054-.054.1-.1.152-.161a1.076,1.076,0,0,0-.027-1.357,1,1,0,0,0-1.322-.17,1.613,1.613,0,0,0-.295.259q-2.772,2.772-5.536,5.536c-.054.054-.1.125-.17.214M39.262,14A11.166,11.166,0,1,1,28.109,2.82,11.167,11.167,0,0,1,39.262,14",
    transform: "translate(-16.93 -2.82)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleSolidGreen);
export default __webpack_public_path__ + "static/media/tick-circle-solid-green.0574c2a13acc5e21580ec38a32a5e271.svg";
export { ForwardRef as ReactComponent };